import CroustilleElement from "../lib/CroustilleElement";

class CityItem extends CroustilleElement {
  constructor() {
    super("city-item");
  }

  handleToggleClick() {
    if (this.items.dataset.open === "true") {
      this.items.dataset.open = "false";
      this.dataset.open = "false";
    } else if (this.items.dataset.open === "false") {
      this.items.dataset.open = "true";
      this.dataset.open = "true";
    }
  }

  init() {
    this.toggle = this.child("toggle");
    this.items = this.child("items");
    this._handleToggleClick = this.handleToggleClick.bind(this);

    this.toggle &&
      this.toggle.addEventListener("click", this._handleToggleClick);
  }

  destroy() {
    this.toggle &&
      this.toggle.removeEventListener("click", this._handleToggleClick);
  }
}

export default CityItem;
